import React, { useState } from 'react';
import styles from './index.module.less';
import ModelTitle from 'components/ModelTitle';
import Image, { StaticImageData } from 'next/image';
import p1Left from '~/images/products/01L.png';
import p1right from '~/images/products/01R.png';
import p3Left from '~/images/products/02L.png';
import p3right from '~/images/products/02R.png';
import Icon from 'components/Icon';
import classNames from 'classnames';

const Products: React.FC = () => {
  const [gamesDetail] = useState([
    {
      title: '碧蓝航线',
      title_en: 'AZUR LANE',
      introduction:
        '公司代表作《碧蓝航线》于2017年6月2\n日开始全平台公测，并已登陆海内外市\n场，取得优秀的成绩。游戏以舰船为题\n材，玩家可通过丰富的玩法，收集并养\n成强力的角色与装备，指挥属于自己的\n舰队征战四海。',
      imageLeft: p1Left,
      imageRight: p1right,
      // 官网地址
      website: 'https://game.bilibili.com/blhx/',
    },
    {
      title: '蓝色星原：旅谣',
      title_en: 'AZUR PROMILIA',
      introduction:
        '《蓝色星原：旅谣》是由蛮啾网络推出的\n一款全新星宠结伴幻想大世界RPG。向往\n星原的奇幻旅途，将与你再次重逢。\n\n星临者，欢迎回到普罗米利亚!',
      imageLeft: p3Left,
      imageRight: p3right,
      // 官网地址
      website: 'https://azurpromilia.manjuu.com/home/',
    },
  ]);

  const [currDetail, setCurrDetail] = useState<{
    title: string;
    title_en: string;
    introduction: string;
    imageLeft: StaticImageData;
    imageRight: StaticImageData;
    website: string;
  }>(gamesDetail[0]);

  const switchDetail = (direction: 'next' | 'prev') => {
    const currentIndex = gamesDetail.findIndex(
      game => game.title_en === currDetail.title_en
    );
    const newIndex =
      direction === 'next'
        ? (currentIndex + 1) % gamesDetail.length
        : (currentIndex - 1 + gamesDetail.length) % gamesDetail.length;
    setCurrDetail(gamesDetail[newIndex]);
  };

  return (
    <div className={styles.mj_product_container}>
      <ModelTitle title="产品介绍" type="games" />
      <div className={styles.mj_product_detail_container}>
        <div className={styles.mj_product_detail_left}>
          <Image
            draggable={false}
            onContextMenu={e => e.preventDefault()}
            className={styles.mj_product_detail_left_image}
            src={currDetail.imageLeft}
            alt=""
          />
        </div>
        <div className={styles.mj_product_detail_middle}>
          <div className={styles.mj_product_detail_middle_title}>
            {currDetail.title_en}
          </div>
          <div className={styles.mj_product_detail_middle_title_zh}>
            {currDetail.title}
          </div>
          <div
            className={styles.mj_product_detail_middle_btn}
            onClick={() => {
              location.href = currDetail.website;
            }}>
            前往官网
          </div>
          <div className={styles.mj_product_detail_middle_goodTitle_zh}>
            产品简介
          </div>
          <div className={styles.mj_product_detail_middle_goodTitle_en}>
            INTRODUCTION
          </div>
          <div className={styles.mj_product_detail_middle_text}>
            {currDetail.introduction}
          </div>
          <div className={styles.mj_product_detail_middle_btnAll}>
            <div
              onClick={() => switchDetail('prev')}
              className={classNames([
                styles.mj_product_detail_middle_btn,
                styles.mj_product_detail_middle_btn_left,
              ])}>
              <Icon
                className={styles.mj_position_jobs_btn_icon}
                fontClass="jiantou-41"
              />
            </div>
            <div
              onClick={() => switchDetail('next')}
              className={styles.mj_product_detail_middle_btn}>
              <Icon
                className={styles.mj_position_jobs_btn_icon}
                fontClass="jiantou-41"
              />
            </div>
          </div>
        </div>

        <div className={styles.mj_product_detail_right}>
          <Image
            draggable={false}
            onContextMenu={e => e.preventDefault()}
            className={styles.mj_product_detail_right_image}
            src={currDetail.imageRight}
            alt=""
          />
        </div>
      </div>
    </div>
  );
};

export default Products;
